import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { IconStateVisual } from '../../../../services/forms-template.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-check-visual-el',
  templateUrl: './check-visual-el.component.html',
  styleUrls: ['./check-visual-el.component.css']
})

export class CheckVisualElComponent implements OnInit, OnChanges {
  @Input() fileDataInput: any
  @Input() dataValue: boolean | string | number
  @Input() dataInput: any;
  value = undefined
  @Input() formGroup
  @Input() tabIndex;
  config: IconStateVisual | undefined
  private trueCustom: SafeHtml | undefined
  private falseCustom: SafeHtml | undefined
  get trueHtml() {
    if (this.trueCustom) return this.trueCustom
  }
  get falseHtml() {
    if (this.falseCustom) return this.falseCustom
  }
  constructor(private sanitizer: DomSanitizer, private cdr: ChangeDetectorRef) {

  }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.config) {
      if (changes.dataValue) {
        if (changes.dataValue.currentValue === this.config.trueValue) this.value = true
        if (changes.dataValue.currentValue === this.config.falseValue) this.value = false
        if (changes.dataValue.currentValue === null) this.value = undefined
        this.cdr.detectChanges()
      }
    }
    return
  }

  ngOnInit() {
    this.config = this.fileDataInput.iconStateVisual
    if (this.config && this.config.type === 'custom') {
      if (this.config.customTrue) {
        this.trueCustom = this.sanitizer.bypassSecurityTrustHtml(this.config.customTrue.html)
      }
      if (this.config.customFalse) {
        this.falseCustom = this.sanitizer.bypassSecurityTrustHtml(this.config.customFalse.html)
      }
    }
    // switch (typeof this.dataValue) {
    //   case 'boolean':
    //     this.value = this.dataValue;
    //     break;
    //   case 'string':
    //   case 'number':
    //     this.value = this.dataValue === this.config.trueValue ? true : false
    //     break;
    //   default:
    //     this.value = undefined
    //     break;
    // }
    this.cdr.detectChanges()

  }

}
